import { createSelector } from "reselect";

const applicantStateSelector = (state) => state.applicant;
const selectById = (state, itemId) => itemId;

export const applicantSelector = createSelector(
  [applicantStateSelector],
  (applicant) => applicant.items
);

export const applicantAsLabelAndValueSelector = createSelector(
  [applicantSelector],
  (applicant) =>
    applicant.map(({ _id, businessName }) => ({
       _id,
     businessName,
    }))
);

export const artisanByIdSelector = createSelector(
  [applicantSelector, selectById],
  (applicant, _id) => {
    const product = applicant.find((item) => _id === item._id);
    if (!product) return null;
    return product;
  }
);


/**
 * Misc
 */

 export const applicantsIsLoadingSelector = createSelector(
  [applicantStateSelector],
  (applicants) => applicants.isLoading
);

export const applicantIsLoadingSelector = createSelector(
  [applicantStateSelector],
  (applicant) => applicant.isLoading
);

export const applicantCountSelector = createSelector(
  [applicantStateSelector],
  (applicant) => applicant.count
);

export const searchValueSelector = createSelector(
  [applicantStateSelector],
  (applicant) => applicant.searchValue
);
